export const SHORTER_SUF_FLAG_KEY = "shorter-suf";
